import api from './api';

const BASE = '/cash-sessions';

export default {
  me: () =>
    api.get(`${BASE}/me`, {
      params: { functionCode: 'CASH_VIEW' },
    }).then((r) => r.data),

  userOverview: (userId) =>
    api.get(`${BASE}/management/users/${userId}`, {
      params: { functionCode: 'CASH_MANAGEMENT_VIEW' },
    }).then((r) => r.data),

  myHistory: (params = {}) =>
    api.get(`${BASE}/history/mine`, {
      params: { functionCode: 'CASH_HISTORY_VIEW', ...params },
      skipGlobalLoading: true,
    }).then((r) => r.data),

  userHistory: (userId, params = {}) =>
    api.get(`${BASE}/management/users/${userId}/history`, {
      params: { functionCode: 'CASH_MANAGEMENT_VIEW', ...params },
      skipGlobalLoading: true,
    }).then((r) => r.data),

  myCombinedHistory: (params = {}) =>
    api.get(`${BASE}/history/mine/combined`, {
      params: { functionCode: 'CASH_HISTORY_VIEW', ...params },
      skipGlobalLoading: true,
    }).then((r) => r.data),

  userCombinedHistory: (userId, params = {}) =>
    api.get(`${BASE}/management/users/${userId}/history/combined`, {
      params: { functionCode: 'CASH_MANAGEMENT_VIEW', ...params },
      skipGlobalLoading: true,
    }).then((r) => r.data),

  get: (id) =>
    api.get(`${BASE}/${id}`, {
      params: { functionCode: 'CASH_VIEW' },
    }).then((r) => r.data),

  requestOpen: (data) =>
    api.post(`${BASE}/requests/open`, {
      ...data,
      functionCode: 'CASH_OPEN',
    }).then((r) => r.data),

  requestApport: (data) =>
    api.post(`${BASE}/requests/apport`, {
      ...data,
      functionCode: 'CASH_APPORT',
    }).then((r) => r.data),

  requestRetrait: (data) =>
    api.post(`${BASE}/requests/retrait`, {
      ...data,
      functionCode: 'CASH_WITHDRAW',
    }).then((r) => r.data),

  requestClose: (data) =>
    api.post(`${BASE}/requests/close`, {
      ...data,
      functionCode: 'CASH_CLOSE',
    }).then((r) => r.data),

  approveRequest: (requestId, data = {}) =>
    api.post(`${BASE}/requests/${requestId}/approve`, {
      ...data,
      functionCode: 'CASH_MANAGEMENT_VIEW',
    }).then((r) => r.data),

  rejectRequest: (requestId, data = {}) =>
    api.post(`${BASE}/requests/${requestId}/reject`, {
      ...data,
      functionCode: 'CASH_MANAGEMENT_VIEW',
    }).then((r) => r.data),

  directOpenForUser: (userId, data = {}) =>
    api.post(`${BASE}/management/users/${userId}/direct-open`, {
      ...data,
      functionCode: 'CASH_DIRECT_OPEN',
    }).then((r) => r.data),

  directApportForUser: (userId, data = {}) =>
    api.post(`${BASE}/management/users/${userId}/direct-apport`, {
      ...data,
      functionCode: 'CASH_DIRECT_APPORT',
    }).then((r) => r.data),

  directRetraitForUser: (userId, data = {}) =>
    api.post(`${BASE}/management/users/${userId}/direct-retrait`, {
      ...data,
      functionCode: 'CASH_DIRECT_WITHDRAW',
    }).then((r) => r.data),

  directCloseForUser: (userId, data = {}) =>
    api.post(`${BASE}/management/users/${userId}/direct-close`, {
      ...data,
      functionCode: 'CASH_DIRECT_CLOSE',
    }).then((r) => r.data),
};